import React from 'react';
import { cropsData } from '../../data/mock';
import Reveal from './Reveal';

const CropsShowcase = () => {
  return (
    <section id="crops" className="py-20 md:py-28 bg-white" data-testid="crops-section">
      <div className="container mx-auto px-4 lg:px-8 max-w-6xl">
        {/* Header */}
        <Reveal className="text-center mb-12 md:mb-16">
          <p className="text-[#0C6951] text-sm font-bold tracking-[0.15em] uppercase mb-4">
            What We Grow
          </p>
          <h2 className="text-3xl md:text-5xl font-black text-[#004534] mb-4">
            Premium Fruit Crops
          </h2>
          <p className="text-gray-600 text-base md:text-lg max-w-xl mx-auto">
            High-value organic fruits selected for yield and strong market demand
          </p>
        </Reveal>

        {/* Grid: 1 col on small phones, 2 on larger phones, 4 on desktop */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {cropsData.map((crop, index) => (
            <Reveal key={index} delay={index * 90} className="h-full">
              <div className="group relative rounded-3xl overflow-hidden shadow-[0_4px_30px_rgba(0,69,52,0.08)] hover:shadow-[0_16px_50px_rgba(0,69,52,0.18)] transition-all duration-500 h-full" data-testid={`crop-${index}`}>
                {/* Image */}
                <div className="aspect-[4/5] overflow-hidden">
                  <img
                    src={crop.image}
                    alt={crop.name}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-1000 ease-out"
                    loading="lazy"
                  />
                </div>

                {/* Gradient overlay + caption (always visible - touch friendly) */}
                <div className="absolute inset-0 bg-gradient-to-t from-[#00281e] via-[#00281e]/45 to-transparent" />
                <div className="absolute inset-x-0 bottom-0 p-5">
                  <span className="block w-8 h-1 bg-[#c4e538] rounded-full mb-3 group-hover:w-12 transition-all duration-500" />
                  <h3 className="font-black text-white text-lg md:text-xl mb-1.5 drop-shadow">
                    {crop.name}
                  </h3>
                  <p className="text-white/80 text-sm leading-relaxed">
                    {crop.description}
                  </p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CropsShowcase;
